export enum TabHeader {
  AllCalls = 'All Calls',
  Pending = 'Pending',
  Confirmed = 'Confirmed',
  Rescheduled = 'Rescheduled',
  Cancelled = 'Cancelled',
  Declined = 'Declined',
}
